import React from 'react';
import { Switch, FormControlLabel } from '@mui/material';

const DAYS = [
  { key: 'monday', label: 'Monday' },
  { key: 'tuesday', label: 'Tuesday' },
  { key: 'wednesday', label: 'Wednesday' },
  { key: 'thursday', label: 'Thursday' },
  { key: 'friday', label: 'Friday' },
  { key: 'saturday', label: 'Saturday' },
  { key: 'sunday', label: 'Sunday' },
];

const DEFAULT_HOURS = {
  monday: { open: '09:00', close: '21:00', closed: false },
  tuesday: { open: '09:00', close: '21:00', closed: false },
  wednesday: { open: '09:00', close: '21:00', closed: false },
  thursday: { open: '09:00', close: '21:00', closed: false },
  friday: { open: '09:00', close: '21:00', closed: false },
  saturday: { open: '09:00', close: '21:00', closed: false },
  sunday: { open: '10:00', close: '18:00', closed: false },
};

const StoreHoursEditor = ({ storeHours, onChange }) => {
  const hours = storeHours || DEFAULT_HOURS;

  const handleChange = (day, field, value) => {
    const updated = {
      ...hours,
      [day]: {
        ...hours[day],
        [field]: value,
      },
    };
    onChange(updated);
  };

  const handleToggleClosed = (day) => {
    const updated = {
      ...hours,
      [day]: {
        ...hours[day],
        closed: !hours[day].closed,
      },
    };
    onChange(updated);
  };

  const copyToAllWeekdays = (sourceDay) => {
    const sourceHours = hours[sourceDay];
    const updated = { ...hours };
    DAYS.slice(0, 5).forEach((day) => {
      updated[day.key] = { ...sourceHours };
    });
    onChange(updated);
  };

  return (
    <div>
      <p className="helper-text">
        Set your store's operating hours for each day of the week.
      </p>

      <div className="hours-grid">
        {DAYS.map((day) => (
          <div key={day.key} className="hours-row">
            <span className="day-label">{day.label}</span>

            {hours[day.key]?.closed ? (
              <span style={{ color: '#999', fontStyle: 'italic', flex: 1 }}>
                Closed
              </span>
            ) : (
              <div className="time-inputs">
                <input
                  type="time"
                  value={hours[day.key]?.open || '09:00'}
                  onChange={(e) => handleChange(day.key, 'open', e.target.value)}
                />
                <span>to</span>
                <input
                  type="time"
                  value={hours[day.key]?.close || '21:00'}
                  onChange={(e) => handleChange(day.key, 'close', e.target.value)}
                />
              </div>
            )}

            <div className="closed-toggle">
              <FormControlLabel
                control={
                  <Switch
                    checked={hours[day.key]?.closed || false}
                    onChange={() => handleToggleClosed(day.key)}
                    size="small"
                  />
                }
                label="Closed"
                labelPlacement="start"
              />
            </div>
          </div>
        ))}
      </div>

      <div style={{ marginTop: 20 }}>
        <button
          type="button"
          onClick={() => copyToAllWeekdays('monday')}
          style={{
            padding: '8px 15px',
            background: 'none',
            border: '1px solid #ddd',
            borderRadius: 6,
            cursor: 'pointer',
            fontSize: 13,
            color: '#666',
          }}
        >
          Copy Monday hours to all weekdays
        </button>
      </div>
    </div>
  );
};

export default StoreHoursEditor;
